<button class="do3-secondary-btn lightBlue mb-3">
  <ng-content></ng-content>
</button>
